import Super from 'client-portal/routes/-request/service';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetService extends Super {}
